import Vue from 'vue'

// Pollyfills
import svg4everybody from 'svg4everybody'
import objectFitImages from 'object-fit-images'

// SASS
import '../scss/main.scss'

// Pre Fab
// Modal
import Modal from './components/modal/index'
// Player
import Player from './components/player/index'
// Disclosure
import Disclosure from './components/disclosure/index'
// Accordion
import Accordion from './components/accordion/index'
// Intersection Observer
import BaseIntersection from './components/BaseIntersection'
// Gets Window Width
import BaseWindowWidth from './components/BaseWindowWidth'
// A11y
import DiscernibleContent from './components/DiscernibleContent'
// Animation
import BaseAnimation from './components/BaseAnimation'
import BaseAnimationItem from './components/BaseAnimationItem'
// Video Wrapper
import BaseCoverContainer from './components/BaseCoverContainer'

// Components
import FormSelect from './components/FormSelect'
import TransitionMenu from './components/TransitionMenu'
import TransitionHeight from './components/TransitionHeight'
import HeaderContainer from './components/HeaderContainer'
import HeaderContainerNav from './components/HeaderContainerNav'
import BaseIntersectionHero from './components/BaseIntersectionHero'
import HeaderContainerDispatch from './components/HeaderContainerDispatch'
import SidebarDisclosure from './components/SidebarDisclosure'
import SwiperGallery from './components/SwiperGallery'
import YoutubePlaylist from './components/YoutubePlaylist'
import CenterNav from './components/CenterNav'
import MenuItem from './components/MenuItem'
import LibrarySearchBar from './components/LibrarySearchBar.vue'

const Components = {
  ...Modal,
  ...Player,
  ...Accordion,
  ...Disclosure,
  SwiperGallery,
  TransitionHeight,
  BaseWindowWidth,
  BaseAnimation,
  BaseIntersection,
  BaseIntersectionHero,
  BaseAnimationItem,
  BaseCoverContainer,
  DiscernibleContent,
  FormSelect,
  TransitionMenu,
  HeaderContainerNav,
  HeaderContainer,
  HeaderContainerDispatch,
  SidebarDisclosure,
  YoutubePlaylist,
  CenterNav,
  MenuItem,
  LibrarySearchBar,
}

Object.keys(Components).forEach(componentName =>
  Vue.component(componentName, Components[componentName]),
)
console.log(Components)
console.log(CenterNav)
window.vueMounted = false

// Pollyfill invocation in mounted
new Vue({
  mounted() {
    svg4everybody()
    objectFitImages()
    // Other scripts can check window.vueMounted to determine if vue is mounted
    // Certain actions like adding listeners can only be done after vue mounted
    window.vueMounted = true
  },
}).$mount('#app')

// Analytics stuff
{
  function addListenerToId(id) {
    const el = document.getElementById(id)
    if (el) {
      el.addEventListener('click', (event) => {
        if (event.target.href && event.target.tagName === 'A') {
          // eslint-disable-next-line no-undef
          dataLayer.push({
            event: 'uaCustomEvent',
            uaEventCategory: `${id} Action`,
            uaEventAction: 'Click',
            uaEventLabel: event.target.href,
          })
        }
      })
    }
  }
  const listenParentIds = [
    'global-header',
    'the-nav-disclosure',
    'footer',
    'homepage-hero-nav',
  ]
  listenParentIds.forEach((id) => {
    addListenerToId(id)
  })
  Vue.config.errorHandler = true
}



// WEBPACK FOOTER //
// ./src/js/main.js